const healthTutorial = {
  module: 'health',
  moduleName: 'Device Health',
  steps: [
    { target: '.page-title', position: 'bottom', title: 'Device Health', description: 'Track errors, warnings, and issues across all monitored devices.' },
    { target: '.md-chart-tooltip', position: 'top', title: 'Trend Charts', description: 'Visualize health patterns over time to spot recurring issues.' },
  ],
};
export default healthTutorial;
